import React, { createContext, useState, useContext, useEffect } from "react";
import { IncomingGoodsService } from "../../../services/logistic/incomingGoods";
import { callErrorToast } from "../../../utilities";
import { dictionary } from "../../../utilities/dictionary";

const incomingGoodsService = new IncomingGoodsService();

export const ConfirmIncomingGoodContext = createContext();

const ConfirmIncomingGoodProvider = ({ children, data, callback }) => {
  const [incomingGoods, setIncomingGood] = useState(data);
  const [incomingGoodsError, setIncomingGoodsError] = useState(null);
  const [incomingGoodsLoader, setIncomingGoodsLoader] = useState(false);

  const confirmIncomingGoods = () => {
    setIncomingGoodsLoader(true);
    const promises = incomingGoods.map((elem) => {
      return incomingGoodsService.confirm(elem);
    });
    Promise.all(promises)
      .then((response) => {
        setIncomingGoodsLoader(false);
        callback();
      })
      .catch((err) => {
        setIncomingGoodsError(err);
      });
  };

  useEffect(() => {
    if (incomingGoodsError) {
      callErrorToast(incomingGoodsError, dictionary);
    }
  }, [incomingGoodsError]);

  return (
    <ConfirmIncomingGoodContext.Provider
      value={{
        incomingGoods,
        incomingGoodsLoader,
        confirmIncomingGoods,

        callback,
      }}
    >
      {children}
    </ConfirmIncomingGoodContext.Provider>
  );
};

const useIncomingGoodContext = () => {
  return useContext(ConfirmIncomingGoodContext);
};

export { ConfirmIncomingGoodProvider, useIncomingGoodContext };
